define('TescoMobile_Catalog/js/action/full-overview-load',['jquery', 'mage/url'], function ($, urlBuilder) {
  'use strict';

  return function (deferred, sku) {
    deferred = deferred || $.Deferred();
    urlBuilder.setBaseUrl(window.BASE_URL);
    const serviceUrl = urlBuilder.build('rest/V1/product/get-full-overview/' + sku);
    return $.ajax({
      url: serviceUrl,
      type: 'GET',
      dataType: 'html'
    }).done(function (response) {
      deferred.resolve(response);
    }).fail(function (response) {
      deferred.reject();
    });
  };
});

